<template>
  <div class="home">
    <div class="header">
      <a class="logo" href="/">
        <div class="text">虎年头像生成器</div>
      </a>
      <div class="author">
        <a href="https://thuscn.com/lab/" target="_blank">
          by
          <div class="author-name">
            <svg
              width="85"
              height="24"
              viewBox="0 0 412 115"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M57.5 39.2H37.6V93H22V39.2H2V28.1H57.5V39.2ZM112.573 93H97.9727V59.2C97.9727 56.5333 97.506 54.7667 96.5727 53.9C95.706 53.0333 93.5727 52.6 90.1727 52.6C85.9727 52.6 83.306 53.0333 82.1727 53.9C81.0393 54.7 80.4727 56.4667 80.4727 59.2V93H65.8727V23H80.4727V50.5C81.406 45.9 86.506 43.6 95.7727 43.6C102.173 43.6 106.573 44.7667 108.973 47.1C111.373 49.3667 112.573 52.8333 112.573 57.5V93ZM172.045 93H157.645V87.1C156.512 91.7 151.345 94 142.145 94C135.745 94 131.345 92.8667 128.945 90.6C126.545 88.2667 125.345 84.7667 125.345 80.1V44.6H139.945V78.1C139.945 80.7667 140.379 82.5667 141.245 83.5C142.179 84.4333 144.345 84.9 147.745 84.9C151.945 84.9 154.612 84.4667 155.745 83.6C156.879 82.6667 157.445 80.8333 157.445 78.1V44.6H172.045V93ZM226.518 74.1V80.2C226.518 82.6 226.051 84.6667 225.118 86.4C224.251 88.1333 223.118 89.5 221.718 90.5C220.385 91.4333 218.618 92.1667 216.418 92.7C214.218 93.2333 212.085 93.5667 210.018 93.7C208.018 93.9 205.651 94 202.918 94C197.651 94 191.285 93.5 183.818 92.5V82.8C193.085 84.2 199.518 84.9 203.118 84.9C205.985 84.9 208.185 84.6333 209.718 84.1C211.318 83.5 212.118 82.3667 212.118 80.7V77.7C212.118 76.1667 211.685 75.0333 210.818 74.3C209.951 73.5 208.085 73.1 205.218 73.1H198.918C193.851 73.1 189.885 72.1 187.018 70.1C184.218 68.0333 182.818 65.0333 182.818 61.1V55.2C182.818 50.8 184.918 47.7667 189.118 46.1C193.318 44.4333 199.251 43.6 206.918 43.6C210.118 43.6 215.851 43.9 224.118 44.5V53.8C213.718 53 207.851 52.6 206.518 52.6C202.451 52.6 199.885 52.9 198.818 53.5C197.751 54.0333 197.218 55.1 197.218 56.7V59.3C197.218 60.1 197.618 60.8333 198.418 61.5C199.285 62.1667 200.585 62.5 202.318 62.5H208.718C220.585 62.5 226.518 66.3667 226.518 74.1Z"
                fill="#333"
              />
              <path
                d="M290.5 93H243V28.1H258.6V81.9H290.5V93ZM344.008 93H329.708V88.6C328.641 90.5333 327.108 91.9333 325.108 92.8C323.108 93.6 319.441 94 314.108 94C307.574 94 303.241 93 301.108 91C298.974 89 297.908 84.8333 297.908 78.5C297.908 72.7667 299.008 68.8 301.208 66.6C303.408 64.3333 307.341 63.2 313.008 63.2H329.408V59.9C329.408 56.9667 328.708 55.0333 327.308 54.1C325.974 53.1 323.108 52.6 318.708 52.6C314.574 52.6 308.908 53 301.708 53.8V44.6C307.241 43.9333 313.408 43.6 320.208 43.6C329.141 43.6 335.341 44.7 338.808 46.9C342.274 49.0333 344.008 53.3 344.008 59.7V93ZM329.408 80.6V71.2H319.408C316.208 71.2 314.208 71.5667 313.408 72.3C312.608 73.0333 312.208 75 312.208 78.2C312.208 81.3333 312.608 83.2333 313.408 83.9C314.274 84.5667 316.408 84.9 319.808 84.9C321.474 84.9 322.708 84.9 323.508 84.9C324.308 84.8333 325.174 84.7333 326.108 84.6C327.041 84.4667 327.674 84.2667 328.008 84C328.408 83.6667 328.741 83.2333 329.008 82.7C329.274 82.1667 329.408 81.4667 329.408 80.6ZM406.453 59.9V75.8C406.453 82.4 404.453 87.1 400.453 89.9C396.52 92.6333 390.153 94 381.353 94C372.086 94 365.686 92.5667 362.153 89.7C358.62 86.7667 356.853 82.1333 356.853 75.8V23H371.453V49.4C372.32 47.2 373.92 45.7 376.253 44.9C378.653 44.0333 382.286 43.6 387.153 43.6C391.286 43.6 394.653 43.9333 397.253 44.6C399.853 45.2667 401.82 46.3667 403.153 47.9C404.486 49.3667 405.353 51 405.753 52.8C406.22 54.6 406.453 56.9667 406.453 59.9ZM391.853 77.7V59.8C391.853 56.6667 391.253 54.7 390.053 53.9C388.92 53.0333 386.053 52.6 381.453 52.6C377.32 52.6 374.62 53.1333 373.353 54.2C372.086 55.2667 371.453 57.1333 371.453 59.8V77.7C371.453 80.5667 372.053 82.5 373.253 83.5C374.52 84.4333 377.286 84.9 381.553 84.9C385.82 84.9 388.586 84.4333 389.853 83.5C391.186 82.5 391.853 80.5667 391.853 77.7Z"
                fill="#333"
              />
            </svg>
          </div>
        </a>
      </div>
    </div>
    <div class="avatarmaker-box">
      <div class="clear-avatar" v-if="avatarImg" @click="clearAvatar">
        <svg
          width="20"
          height="20"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.418 40.8203C31.3164 40.8203 40.3398 31.7969 40.3398 20.8984C40.3398 10.0195 31.2969 0.976562 20.3984 0.976562C9.51953 0.976562 0.496094 10.0195 0.496094 20.8984C0.496094 31.7969 9.53906 40.8203 20.418 40.8203ZM20.418 37.5C11.1992 37.5 3.83594 30.1172 3.83594 20.8984C3.83594 11.6992 11.1797 4.29688 20.3984 4.29688C29.6172 4.29688 37 11.6992 37.0195 20.8984C37.0391 30.1172 29.6367 37.5 20.418 37.5ZM13.7383 29.1797C14.168 29.1797 14.5781 29.0039 14.8516 28.6914L20.3984 23.125L25.9648 28.6914C26.2578 28.9844 26.6289 29.1797 27.0781 29.1797C27.9375 29.1797 28.6406 28.457 28.6406 27.5977C28.6406 27.1484 28.4844 26.7773 28.1719 26.4844L22.625 20.9375L28.1914 15.3516C28.5234 15.0195 28.6602 14.6875 28.6602 14.2578C28.6602 13.3789 27.957 12.6953 27.0977 12.6953C26.6875 12.6953 26.3555 12.832 26.0234 13.1641L20.3984 18.75L14.8125 13.1836C14.5391 12.8711 14.168 12.7344 13.7383 12.7344C12.8789 12.7344 12.1758 13.3984 12.1758 14.2773C12.1758 14.707 12.332 15.0781 12.6445 15.3711L18.1914 20.9375L12.6445 26.5039C12.332 26.7773 12.1758 27.168 12.1758 27.5977C12.1758 28.457 12.8789 29.1797 13.7383 29.1797Z"
            fill="#d5d3ca"
          ></path>
        </svg>
      </div>
      <div class="avatarmaker-cell" id="avatarmaker">
        <div class="tips" v-if="avatarImg == null" @click="selectImage">
          上传图片
        </div>
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          class="file-input"
          @input="pickFile"
        />
        <div class="clone-darg">
          <VueDragResize
            :isResizable="false"
            :isActive="true"
            :w="400"
            :h="400"
            v-on:resizing="resize"
            v-on:dragging="resize"
          >
            <div class="img"></div>
          </VueDragResize>
        </div>
        <div class="mask" :class="'mask' + avatarMask" v-if="avatarImg"></div>

        <div class="img" :style="{ top: top + 'px', left: left + 'px' }">
          <img
            :src="avatarImg"
            :style="{ transform: 'scale(' + scale + ')' }"
          />
        </div>
      </div>
    </div>
    <div class="avatarmaker-style">
      <div class="style-list" :class="[avatarImg ? '' : 'disable']">
        <div class="style-item">
          <input
            type="radio"
            name="avatarMaskStyle"
            id="mask01"
            :title="1"
            v-on:change="changeStyle"
            checked
          />
          <label for="mask01"></label>
          <span>虎年大吉</span>
        </div>
        <div class="style-item">
          <input
            type="radio"
            name="avatarMaskStyle"
            id="mask02"
            :title="2"
            v-on:change="changeStyle"
          />
          <label for="mask02"></label>
          <span>虎头帽</span>
        </div>
        <div class="style-item">
          <input
            type="radio"
            name="avatarMaskStyle"
            id="mask03"
            :title="3"
            v-on:change="changeStyle"
          />
          <label for="mask03"></label>
          <span>新年好</span>
        </div>
        <div class="style-item">
          <input
            type="radio"
            name="avatarMaskStyle"
            id="mask04"
            title="4"
            v-on:change="changeStyle"
          />
          <label for="mask04"></label>
          <span>虎年招牌</span>
        </div>
        <div class="style-item">
          <input
            type="radio"
            name="avatarMaskStyle"
            id="mask05"
            title="5"
            v-on:change="changeStyle"
          />
          <label for="mask05"></label>
          <span>虎年如意</span>
        </div>
        <div class="style-item">
          <input
            type="radio"
            name="avatarMaskStyle"
            id="mask06"
            :title="6"
            v-on:change="changeStyle"
          />
          <label for="mask06"></label>
          <span>虎虎生威</span>
        </div>
        <div class="style-item">
          <input
            type="radio"
            name="avatarMaskStyle"
            id="mask07"
            :title="7"
            v-on:change="changeStyle"
          />
          <label for="mask07"></label>
          <span>虎到福到</span>
        </div>
        <div class="style-item">
          <input
            type="radio"
            name="avatarMaskStyle"
            id="mask08"
            title="8"
            v-on:change="changeStyle"
          />
          <label for="mask08"></label>
          <span>寅虎招财</span>
        </div>
        <div class="style-item">
          <input
            type="radio"
            name="avatarMaskStyle"
            id="mask09"
            title="9"
            v-on:change="changeStyle"
          />
          <label for="mask09"></label>
          <span>新年快乐</span>
        </div>
        <div class="style-item">
          <input
            type="radio"
            name="avatarMaskStyle"
            id="mask10"
            title="10"
            v-on:change="changeStyle"
          />
          <label for="mask10"></label>
          <span>虎年剪纸</span>
        </div>
      </div>
    </div>

    <div class="avatarmaker-zoom">
      <ul>
        <li>
          <button class="zoom-item" @click="zoomOut" :disabled="!avatarImg">
            <svg
              t="1643123158013"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4267"
              width="20"
              height="20"
            >
              <path
                d="M919.264 905.984l-138.912-138.912C851.808 692.32 896 591.328 896 480c0-229.376-186.624-416-416-416S64 250.624 64 480s186.624 416 416 416c95.008 0 182.432-32.384 252.544-86.208l141.44 141.44a31.904 31.904 0 0 0 45.248 0 32 32 0 0 0 0.032-45.248zM128 480C128 285.92 285.92 128 480 128s352 157.92 352 352-157.92 352-352 352S128 674.08 128 480z"
                p-id="4268"
              ></path>
              <path
                d="M625.792 448H336a32 32 0 0 0 0 64h289.792a32 32 0 1 0 0-64z"
                p-id="4269"
              ></path></svg
            >缩小
          </button>
        </li>
        <li>
          <button class="zoom-item" @click="zoomIn" :disabled="!avatarImg">
            <svg
              t="1643123185300"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4403"
              width="20"
              height="20"
            >
              <path
                d="M919.264 905.984l-138.912-138.912C851.808 692.32 896 591.328 896 480c0-229.376-186.624-416-416-416S64 250.624 64 480s186.624 416 416 416c95.008 0 182.432-32.384 252.544-86.208l141.44 141.44a31.904 31.904 0 0 0 45.248 0 32 32 0 0 0 0.032-45.248zM128 480C128 285.92 285.92 128 480 128s352 157.92 352 352-157.92 352-352 352S128 674.08 128 480z"
                p-id="4404"
              ></path>
              <path
                d="M625.792 448H512v-112a32 32 0 0 0-64 0V448h-112a32 32 0 0 0 0 64H448v112a32 32 0 1 0 64 0V512h113.792a32 32 0 1 0 0-64z"
                p-id="4405"
              ></path></svg
            >放大
          </button>
        </li>
      </ul>
    </div>

    <div class="download">
      <button
        class="download-btn"
        @click="generatorImageDialog"
        v-if="Mobile"
        :disabled="!avatarImg"
      >
        下载头像
      </button>
      <button
        class="download-btn"
        @click="generatorImage"
        v-else
        :disabled="!avatarImg"
      >
        下载头像
      </button>
    </div>

    <div class="share">
      <button @click="share" :disabled="disable"><b>😍</b> 推荐给朋友 </button>
    </div>

    <div class="footer">
      <div class="wx-mp"><img src="../assets/img/wx-mp.png" alt="" /></div>
      <ul>
        <li>
          <a target="_blank" href="https://bdd2022.com/">冰墩墩表情生成器</a>
        </li>
        <li><a @click="showTips">隐私说明</a></li>
        <li><a href="/lvwzhen.png">联系作者</a></li>
        <li><a href="https://support.qq.com/products/378327?">意见反馈</a></li>
      </ul>
    </div>

    <van-dialog
      v-model="avatarmakerDialog"
      class="avatarmaker-dialog"
      show-cancel-button
      cancelButtonText="关闭"
      :showConfirmButton="false"
    >
      <div class="avatarmaker-pic">
        <img :src="output" v-if="output" />
        <div class="tips">长按保存图片</div>
      </div>
    </van-dialog>

    <van-dialog
      v-model="tipsDialog"
      class="tips-dialog"
      show-cancel-button
      cancelButtonText="关闭"
      :showConfirmButton="false"
    >
      <div class="content">
        「虎年头像生成器」的图片生成功能仅依赖于本地浏览器，我们不会在服务器中储存或者收集用户的数据和图片。
        <br />
        <br />请遵守当地法律法规，违者后果自负。
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from "vant";
import { Dialog } from "vant";
import Vue from "vue";
import "vant/lib/toast/style";
import "vant/lib/dialog/style";
import domtoimage from "dom-to-image";
import VueDragResize from "vue-drag-resize";
Vue.use(Toast);
Vue.use(Dialog);

export default {
  components: {
    VueDragResize,
  },
  data() {
    return {
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      showText: true,
      showImage: false,
      avatarImg: null,
      avatarMask: 1,
      scale: 1,
      avatarmakerImg: null,
      tipsDialog: false,
      output: null,
      logoFont: "Quicksand",
      msg: "虎年头像生成器：https://hu.lvwzhen.com/",
      fonts: [
        "Quicksand",
        "Roboto",
        "Dela Gothic One",
        "Lato",
        "Zilla Slab Highlight",
        "Oswald",
        "Lora",
        "Inter",
        "Noto Sans SC",
        "Noto Serif SC",
      ],
      avatarMaskStyle: 0,
      avatarmakerText: "MI",
      avatarmakerDialog: false,
      avatarmakerLogo: "",
      previewImage: null,
      Mobile: false,
      disabled: false,
      hue: 50,
      color: "",
      logoBgColor: "",
      message: "https://avatarmaker.lvwzhen.com/",
      avatarmakerUrl:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAADwCAYAAAA+VemSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKuSURBVHgB7dMBDQAgDMCwg3/PcBtLWg89bw2QdAfIEhjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGsA/MRAXc/BABqAAAAABJRU5ErkJggg==",
    };
  },
  methods: {
    share: function () {
      this.$copyText(this.msg).then(
        function () {
          Toast("复制成功，快去分享吧！");
        },
        function () {
          Toast("复制失败");
        }
      );
      this.disabled = true;
      setTimeout(() => {
        this.disabled = false;
      }, 1000);
    },
    showTips() {
      this.tipsDialog = true;
    },
    resize(newRect) {
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    zoomIn() {
      this.scale += 0.1;
    },
    zoomOut() {
      this.scale -= 0.1;
    },
    selectImage() {
      this.$refs.fileInput.click();
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.avatarImg = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    clearAvatar() {
      this.avatarImg = null;
    },
    changeStyle(e) {
      this.avatarMask = e.target.title;
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    clearImage() {
      this.showImage = false;
      this.showText = true;
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        this.showImage = true;
        this.showText = false;
      };
    },
    maker() {
      var node = document.getElementById("avatarmaker");
      var that = this;
      const scale = 2;
      const style = {
        transform: "scale(" + scale + ")",
        transformOrigin: "top left",
        width: node.offsetWidth + "px",
        height: node.offsetHeight + "px",
      };
      const param = {
        height: node.offsetHeight * scale,
        width: node.offsetWidth * scale,
        quality: 1,
        style,
      };
      domtoimage
        .toPng(node, param)
        .then(function () {
          domtoimage.toPng(node, param).then(function (dataUrl) {
            that.output = dataUrl;
            Toast.clear;
            that.avatarmakerDialog = true;
          });
        })
        .catch(function () {});
    },
    generatorImageDialog() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.maker();
    },
    downloadImage(imgsrc, name) {
      //下载图片地址和图片名
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png");
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        a.download = name || "photo";
        a.href = url;
        a.dispatchEvent(event);
      };
      image.src = imgsrc;
    },
    generatorImage() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      setTimeout(() => {
        Toast.clear;
      }, 300);
      var that = this;
      var node = document.getElementById("avatarmaker");
      const scale = 2;
      const style = {
        transform: "scale(" + scale + ")",
        transformOrigin: "top left",
        width: node.offsetWidth + "px",
        height: node.offsetHeight + "px",
      };
      const param = {
        height: node.offsetHeight * scale,
        width: node.offsetWidth * scale,
        quality: 1,
        style,
      };
      domtoimage.toPng(node, param).then(function () {
        domtoimage.toPng(node, param).then(function (dataUrl1) {
          that.downloadImage(dataUrl1, "avatar.png");
        });
      });
    },
  },
  mounted() {
    if (this.isMobile()) {
      this.Mobile = true;
    } else {
      this.Mobile = false;
    }
  },
};
</script>
<style>
@import "~@radial-color-picker/vue-color-picker/dist/vue-color-picker.min.css";
</style>

<style>
.van-uploader__preview-image {
  width: 216px;
  height: 216px;
}
.wx-mp {
  box-shadow: 0 1px 3px #eee;
  border-radius: 5px;
  max-width: 280px;
  overflow: hidden;
  margin: 30px auto 15px;
}
.wx-mp img {
  width: 100%;
  height: auto;
  display: block;
}
</style>